<template>
  <OperationStatus />
  <div
    v-if="navigationLoading"
    class="navigation-loader"
    role="progressbar"
    aria-label="A carregar página"
  >
    <span></span>
  </div>
  <router-view v-slot="{ Component }">
    <component :is="Component" v-if="Component" />
    <main v-else class="app-loading" role="status" aria-live="polite">
      <div class="app-loader-mark">
        <img src="/facturize-logo.png" alt="" />
        <span class="app-loader-ring"></span>
      </div>
      <strong>Facturize</strong>
      <p>A preparar a sua área de trabalho</p>
      <span class="app-loader-track"><span></span></span>
    </main>
  </router-view>
</template>

<script>
import OperationStatus from "@/components/OperationStatus.vue";

export default {
  name: "App",
  components: { OperationStatus },
  data: () => ({ navigationLoading: false, navigationTimer: null }),
  mounted() {
    window.addEventListener(
      "facturize:navigation-start",
      this.onNavigationStart,
    );
    window.addEventListener("facturize:navigation-end", this.onNavigationEnd);
  },
  beforeUnmount() {
    window.removeEventListener(
      "facturize:navigation-start",
      this.onNavigationStart,
    );
    window.removeEventListener(
      "facturize:navigation-end",
      this.onNavigationEnd,
    );
    window.clearTimeout(this.navigationTimer);
  },
  methods: {
    onNavigationStart() {
      window.clearTimeout(this.navigationTimer);
      this.navigationTimer = window.setTimeout(() => {
        this.navigationLoading = true;
      }, 120);
    },
    onNavigationEnd() {
      window.clearTimeout(this.navigationTimer);
      this.navigationLoading = false;
    },
  },
};
</script>

<style>
.app-loading {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #117b91;
  font-family: Arial, sans-serif;
  text-align: center;
  background: radial-gradient(
    ellipse at center,
    #fff 0%,
    #f1f8fa 68%,
    #eaf3f6 100%
  );
}
.navigation-loader {
  position: fixed;
  z-index: 20000;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  overflow: hidden;
  background: rgba(8, 136, 186, 0.12);
  pointer-events: none;
}
.navigation-loader span {
  display: block;
  width: 38%;
  height: 100%;
  border-radius: 4px;
  background: linear-gradient(90deg, #0788ba, #22b8a8);
  animation: app-loader-progress 0.9s ease-in-out infinite;
}
.app-loading strong {
  margin-top: 14px;
  font-size: 1.35rem;
  letter-spacing: 0.02em;
}
.app-loading p {
  margin: 6px 0 18px;
  color: #64748b;
  font-size: 0.92rem;
}
.app-loader-mark {
  position: relative;
  display: grid;
  width: 76px;
  height: 76px;
  place-items: center;
}
.app-loader-mark img {
  width: 42px;
  height: 42px;
  object-fit: contain;
}
.app-loader-ring {
  position: absolute;
  inset: 0;
  border: 3px solid rgba(8, 136, 186, 0.14);
  border-top-color: #0788ba;
  border-right-color: #22b8a8;
  border-radius: 50%;
  animation: app-loader-spin 0.9s cubic-bezier(0.5, 0.1, 0.5, 0.9) infinite;
}
.app-loader-track {
  width: 150px;
  height: 3px;
  overflow: hidden;
  border-radius: 3px;
  background: #dcebef;
}
.app-loader-track span {
  display: block;
  width: 42%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #0788ba, #22b8a8);
  animation: app-loader-progress 1.4s ease-in-out infinite;
}
@keyframes app-loader-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes app-loader-progress {
  from {
    transform: translateX(-110%);
  }
  to {
    transform: translateX(360%);
  }
}

@media (max-width: 767.98px) {
  html,
  body,
  #app {
    max-width: 100%;
    overflow-x: hidden;
  }
  body {
    background: #f4f7fc;
  }

  .dashboard-layout .main-content {
    overflow-x: hidden;
  }
  .dashboard-layout .page-content {
    padding: 82px 0 24px !important;
    background: #f4f7fc;
  }
  .dashboard-layout .page-content > .container-fluid {
    padding-right: 12px !important;
    padding-left: 12px !important;
  }
  .dashboard-layout .card {
    overflow: hidden;
    border: 0 !important;
    border-radius: 16px !important;
    box-shadow: 0 5px 20px rgba(31, 49, 82, 0.07) !important;
  }
  .dashboard-layout .card-body {
    padding: 16px !important;
  }
  .dashboard-layout h4 {
    font-size: 1.1rem;
  }
  .dashboard-layout .row.g-3 {
    --bs-gutter-y: 0.75rem;
  }
  .dashboard-layout .form-control,
  .dashboard-layout .form-select {
    min-height: 46px;
    border-color: #e5eaf2;
    border-radius: 11px;
    font-size: 16px;
  }
  .dashboard-layout textarea.form-control {
    min-height: 90px;
  }
  .dashboard-layout .form-label {
    margin-bottom: 5px;
    font-size: 12px;
    font-weight: 700;
  }
  .dashboard-layout .btn {
    min-height: 44px;
    border-radius: 11px;
  }
  .dashboard-layout .d-flex.justify-content-between {
    flex-wrap: wrap;
    gap: 10px;
  }
  .dashboard-layout .d-flex.justify-content-between > .d-flex,
  .dashboard-layout .d-flex.justify-content-between > .btn,
  .dashboard-layout .d-flex.justify-content-between > .btn-group {
    max-width: 100%;
    flex-wrap: wrap;
  }
  .dashboard-layout .modal-dialog {
    width: 100%;
    max-width: none;
    min-height: 100dvh;
    margin: 0;
  }
  .dashboard-layout .modal-content {
    min-height: 100dvh;
    border: 0;
    border-radius: 0;
  }
  .dashboard-layout .modal-header {
    position: sticky;
    top: 0;
    z-index: 4;
    background: #fff;
  }
  .dashboard-layout .modal-footer {
    position: sticky;
    bottom: 0;
    z-index: 4;
    background: #fff;
  }
  .dashboard-layout .table-responsive,
  .dashboard-layout .datatable-responsive {
    margin-right: -8px;
    margin-left: -8px;
    padding: 0 8px;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
  }
  .dashboard-layout .dt-container .dt-layout-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .dashboard-layout .dt-container .dt-layout-cell {
    width: 100%;
    overflow-x: auto;
  }
  .dashboard-layout .dt-search,
  .dashboard-layout .dt-length {
    width: 100%;
    text-align: left !important;
  }
  .dashboard-layout .dt-search input {
    width: calc(100% - 92px);
    min-height: 40px;
  }
  .dashboard-layout .dt-paging {
    display: flex;
    justify-content: center;
    overflow-x: auto;
  }
  .dashboard-layout footer {
    padding-inline: 12px;
    text-align: center;
  }
  #page-topbar .navbar-header {
    min-width: 0;
    gap: 4px;
    padding-inline: 6px;
  }
  #page-topbar .navbar-header > .d-flex {
    min-width: 0;
  }
  #page-topbar .navbar-header > .d-flex:last-child {
    flex: 1 1 auto;
    justify-content: flex-end;
    gap: 0;
  }
  #page-topbar .navbar-brand-box {
    display: none !important;
  }
  #page-topbar .header-item {
    padding-inline: 8px;
  }
  #page-topbar #active-establishment {
    width: clamp(90px, 32vw, 138px);
    min-width: 0 !important;
    max-width: 138px;
    font-size: 13px;
  }
  #page-topbar .navbar-header > .d-flex:last-child > .d-flex {
    margin-right: 2px !important;
  }
  #page-topbar .header-profile-user {
    width: 30px;
    height: 30px;
  }
  .dashboard-layout .container-fluid,
  .dashboard-layout .card,
  .dashboard-layout .card-body,
  .dashboard-layout .row,
  .dashboard-layout [class*="col-"] {
    min-width: 0;
  }
}
</style>
